import { combineReducers } from 'redux';
import { DownloadActionType, DownloadAction } from '../../actions/downloadActions';

const loading = (state = false, action: DownloadAction) => {
  switch (action.type) {
    case DownloadActionType.GET_WORKER_DOWNLOADS:
      return true;
    case DownloadActionType.GET_WORKER_DOWNLOADS_OK:
    case DownloadActionType.GET_WORKER_DOWNLOADS_ERROR:
      return false;
    default:
      return state;
  }
};

const error = (state = '', action: DownloadAction) => {
  switch (action.type) {
    case DownloadActionType.GET_WORKER_DOWNLOADS:
      return '';
    case DownloadActionType.GET_WORKER_DOWNLOADS_ERROR:
      return action.error;
    default:
      return state;
  }
};

export type WorkerDownloadState = { loading: boolean; loadingError: string };

export default combineReducers({ loading, error });
